import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getInventoryAvailByInvStatus } from './service/inventoryOverview.service';
import { AvailByInvStatusPayload, InventoryAvailByInvStatus, InventoryDetailsTabProps } from './model/inventoryOverview.model';
import Table, { Column } from '../../../Components/Tables/Table';
import Loader from '../../../Components/GlobalLoader/Loader';
import { ApiResponse, CustomQueryResponse } from '../../../model/common/apiResponse';
import { usePagination } from '../../../hooks/usePagination';


export const AvailByInvStatus:React.FC<InventoryDetailsTabProps> = ({
    warehouseId
}) => {
    const { id } = useParams();
    const [availByInvStatusData, setAvailByInvStatusData] = useState<ApiResponse<any> | null>(null);
    const [loading, setLoading] = useState(true);
    const { currentPage, handlePageChange, perPage } = usePagination();
    let payload = { ...AvailByInvStatusPayload };

    const shiptocolumns: Column[] = [
        {
            name: "Inv Status",
            selector: (row: InventoryAvailByInvStatus) => row.description ? row.description : '-',
        },
        {
            name: "Available",
            selector: (row: InventoryAvailByInvStatus) => row.qty_on_hand ? row.qty_on_hand : 0,
        },
        {
            name: "Avail Now",
            selector: (row: InventoryAvailByInvStatus) => row.total_qty_available ? row.total_qty_available : 0,
        }

    ];

    useEffect(() => {
        if (id) {
            setLoading(true);
            payload.conditions = [
                ["item.id", "=", id],
                ["warehouse.id", "=", warehouseId]
            ];
            payload.group = [
                "lookup_status.description"
            ];

            payload.limit = perPage;
            payload.page = currentPage;
            getInventoryAvailByInvStatus(payload).then((response) => {
                setAvailByInvStatusData(response ?? null);

            }).finally(() => {
                setLoading(false);
            });
        }
    }, [id, currentPage]);
    return !loading ? (
        <div className="mb-2 mt-1 bg-white rounded px-4 py-3">
            <Table
                columns={shiptocolumns}
                data={availByInvStatusData?.data?.results || []}
                CheckboxStatus={false}
                isStripped={true}
                customClassName="transferDetailsTable"
                pagination={{
                    recordsPerPage: perPage,
                    totalRecords: availByInvStatusData?.data?.recordsTotal,
                    currentPage: currentPage,
                    onCurrentPageChange: handlePageChange,
                }}
            />
        </div>
    ) : <Loader />;
}
